var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isSearchByImage)?_c('div',{staticClass:"image-search-wrapper",attrs:{"title":"Search by Image"}},[_c('i',{staticClass:"el-icon-camera-solid search-by-image"}),_c('input',{ref:"fileInput",staticClass:"file-input",attrs:{"type":"file","accept":"image/*","title":""},on:{"change":_vm.handleFileUpload}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }